import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		workDays: { tasks: [] },
		workDayById: { tasks: [], user: {} },
		dataSearch: [],
		myWorkday: []
	},

	actions: {
		// new
		fetchAll ({ commit }, { userIds, taskNo, content, projectIds, fromDate, toDate, Page, PerPage }) {
			const urlSearchParams = new URLSearchParams();
			const params = { taskNo, content, fromDate, toDate, Page, PerPage };
			Object.keys(params).forEach(param => {
				if (params[param] !== null && params[param] !== undefined) {
					urlSearchParams.append(param, params[param]);
				} 
			})
			userIds.forEach(id => {
				urlSearchParams.append('userIds', id);
			})
			projectIds.forEach(id => {
				urlSearchParams.append('projectIds', id);
			})
			return window.axios.get('/WorkDays', { params: urlSearchParams }).then((response) => {
				commit(types.STORE_WORKDAYS, response.data)
				return {
					data: response.data,
					total: parseInt(response.headers['x-pagination-total-count'])
				}
			})
		},

		fetchSelf ({ commit }, { fromDate, toDate }) {
			return window.axios.get('/Workdays/self', { params: { fromDate, toDate } }).then(({ data }) => {
				commit(types.STORE_SELF_WORKDAY, data)
				return data
			})
		},

		fetchById ({ commit }, { id }) {
			return window.axios.get(`/WorkDays/${id}`).then(({ data }) => {
				return data
			})
		},

		create ({ commit }, { date, enterTime, leaveTime, userId, taskIds, notes, startDate, endDate }) {
			return window.axios.post('/WorkDays', { date, enterTime, leaveTime, userId, taskIds, notes, startDate, endDate }).then(({ data }) => {
				return data
			})
		},

		update ({ commit }, { id, date, enterTime, leaveTime, userId, taskIds, notes, startDate, endDate }) {
			return window.axios.put(`/WorkDays/${id}`, { date, enterTime, leaveTime, userId, taskIds, notes, startDate, endDate }).then(({ data }) => {
				return data
			})
		},

		fetchWorkDayBetweenTwoDate ({ commit }, { fromDate, toDate }) {
			const urlSearchParams = new URLSearchParams();
			const params = { fromDate, toDate }
			return window.axios.get('/Workdays/dates', { params: { fromDate, toDate } }).then(({ data }) => {
				return data
			})
		},

		delete ({ commit }, { id }) {
			return window.axios.delete(`/workdays/${id}`)
		},

		createWorkDayFromAdministrative ({ commit }, { date, enterTime, leaveTime, userId, taskIds, notes, startDate, endDate }) {
			return window.axios.post('/Workdays/ForEmployee', { date, enterTime, leaveTime, userId, taskIds, notes, startDate, endDate }).then(({ data }) => {
				return data
			})
		}
	},

	mutations: {
		[types.STORE_WORKDAYS] (state, workDays) {
			state.workDays = workDays
		},

		[types.STORE_WORKDAY_BY_ID] (state, workDayById) {
			state.workDayById = workDayById
		},

		[types.STORE_DATA_SEARCH] (state, dataSearch) {
			state.dataSearch = dataSearch
		},

		[types.STORE_SELF_WORKDAY] (state, myWorkday) {
			state.myWorkday = myWorkday
		}
	}
}
